<template>
	<div class="panel bgPanel mt1x cb mr1x ml1x" id="generateHistory">
		<div class="clearfix dateSys titleBar title-bg">
			<span class="fs14x" :title="getLanguageStr('word1698','用电历史')">{{getLanguageStr("word1698","用电历史")}}</span>
			<div class="fR dpIB_E vaM_E">
				<div class="cField tra-fast_E vaM_E posR" @mouseleave="leave">
					<button @mouseenter="paramChooiceShow" :title="getLanguageStr('word566','参数选择')" class="sizeS bdSub pl1x pr1x boxR hover-main">{{getLanguageStr('word566','参数选择')}}</button>
					<DeviceDetailParam ref="DeviceDetailParam" @selectArray="updateShowParamArray" @beingParamArray="beingParamArray"></DeviceDetailParam>
				</div>
				<div class="cField tra-fast_E vaM_E hover-cMain_E">
					<button id="prev" class="w2x fa fa-angle-left fs14x" type="button" :class="{disable:timeChoose[ActiveIndex].type ==='all'}" @click="dateChange('perv')"></button>
					<vue-datepicker-local v-if="timeChoose[ActiveIndex].type ==='all'" v-model="rangeDate" format="YYYY" :local="local" class="sizeS lh20" disabled></vue-datepicker-local>
					<vue-datepicker-local v-else v-model="time" :format="timeChoose[ActiveIndex].format" ref="date" :local="local" class="sizeS lh20" @input="_showChart()" :disabled-date="disabledDate"></vue-datepicker-local>
					<button id="next" class="w2x fa fa-angle-right fs14x" type="button" :class="{disable:timeChoose[ActiveIndex].type ==='all'||timeGetTime==todayGetTime}" @click="dateChange('next')"></button>
				</div>
				<div class="classGroup cField_E bdSub_E tra-fast_E">
					<button type="button" :class="{active:ActiveIndex==index}" v-for="(item,index) in timeChoose" @click="_timePicker(item,index)" :key="index">{{item.datepicker}}</button>
				</div>
			</div>
		</div>
		<div class="mt1x emptyToken_EE posR">
			<loading v-if="isChart" class="chartLoading"></loading>
			<div v-if="!isChart && ActiveIndex==0" class="taC dpIB_E mr1x_E">
				<div><span :title="getLanguageStr('word527','当日用电量')">{{getLanguageStr('word527','当日用电量')}}:</span> <span :title="detailData.statistics?convertData(detailData.statistics.useValue,2,'k','Wh')[0]:'--'">{{detailData.statistics?convertData(detailData.statistics.useValue,2,'k','Wh')[0]:'--'}}</span></div>
			</div>
			<div v-if="!isChart && ActiveIndex==1" class="taC dpIB_E mr1x_E">
				<div><span :title="getLanguageStr('word528','当月用电量')">{{getLanguageStr('word528','当月用电量')}}:</span> <span :title="detailData.statistics?convertData(detailData.statistics.useValue,2,'k','Wh')[0]:'--'">{{detailData.statistics?convertData(detailData.statistics.useValue,2,'k','Wh')[0]:'--'}}</span></div>
			</div>
			<div v-if="!isChart && ActiveIndex==2" class="taC dpIB_E mr1x_E">
				<div><span :title="getLanguageStr('word529','当年用电量')">{{getLanguageStr('word529','当年用电量')}}:</span> <span :title="detailData.statistics?convertData(detailData.statistics.useValue,2,'k','Wh')[0]:'--'">{{detailData.statistics?convertData(detailData.statistics.useValue,2,'k','Wh')[0]:'--'}}</span></div>
			</div>
			<div v-if="!isChart && ActiveIndex==3" class="taC dpIB_E mr1x_E">
				<div><span :title="getLanguageStr('word529','当年用电量')">{{getLanguageStr('word529','当年用电量')}}:</span> <span :title="detailData.statistics?convertData(detailData.statistics.useValue,2,'k','Wh')[0]:'--'">{{detailData.statistics?convertData(detailData.statistics.useValue,2,'k','Wh')[0]:'--'}}</span></div>
			</div>
		</div>
		<div class="pb1x">
			<ChartLine ref="chartLine" :data="ChartData" :option="defChartMonthOption" :chartClass="'h28x'" v-if="ActiveIndex==0"></ChartLine>
			<ChartColumn ref="chartColumn" :data="ChartData" :option="defChartMonthOption" :chartClass="'h28x'" class="h28x" v-else></ChartColumn>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Loading from '@/components/common/ui/Loading';
import ChartLine from '@/components/common/chart/ChartLine.vue';
import ChartColumn from '@/components/common/chart/ChartColumn.vue';
import DeviceDetailParam from '@/view/device/device/part/DeviceDetailParam';// 详情
import NoData from '@/components/common/ui/NoResult';
import * as equipmentApi from '@/api/maintain/plant/list';
import * as lib from '@/util/lib.js';
import {getLocal} from '@/util';
import {getLanguageStr} from '@/util/language.js';

export default {
	name: 'ConsumptionHistory',
	components: {Loading, ChartLine, ChartColumn, DeviceDetailParam, NoData},
	computed: {
		...mapGetters({
			isOpen: 'stationDetail/isOpen'
		}),
		timeGetTime () {
			let year = new Date(this.time).getFullYear();
			let month = new Date(this.time).getMonth() + 1;
			let day = new Date(this.time).getDate();
			if (this.ActiveIndex == 0) {
				return new Date(year + '/' + month + '/' + day).getTime();
			} else if (this.ActiveIndex == 1) {
				return new Date(year + '/' + month).getTime();
			} else if (this.ActiveIndex == 2) {
				return new Date(year).getTime();
			}
		},
		todayGetTime () {
			let year = new Date().getFullYear();
			let month = new Date().getMonth() + 1;
			let day = new Date().getDate();
			if (this.ActiveIndex == 0) {
				return new Date(year + '/' + month + '/' + day).getTime();
			} else if (this.ActiveIndex == 1) {
				return new Date(year + '/' + month).getTime();
			} else if (this.ActiveIndex == 2) {
				return new Date(year).getTime();
			}
		}
	},
	watch: {
		isOpen (val) {
			if (!val) {
				this.ActiveIndex = 0;
			}
		}
	},
	data () {
		return {
			ActiveIndex: 0,
			local: {},
			isChart: true, // 图表数据是否加载完成
			time: new Date(),
			rangeDate: [new Date('2000'), new Date()],
			timeChoose: [{
				datepicker: getLanguageStr('cmd93', '日'),
				format: 'YYYY/MM/DD',
				type: 'day'
			}, {
				datepicker: getLanguageStr('cmd95', '月'),
				format: 'YYYY/MM',
				type: 'month'
				// },{
				// 	datepicker:getLanguageStr("word1195","季度"),
				// 	format:'YYYY/MM',
				// 	type:'quarter'
			}, {
				datepicker: getLanguageStr('cmd96', '年'),
				format: 'YYYY',
				type: 'year'
			}, {
				datepicker: getLanguageStr('cmd97', '总'),
				format: 'YYYY',
				type: 'all'
			}],
			defChartMonthOption: {},
			ChartData: [], // 图标数据,
			detailData: {},
			chartList: [],
			stationId: null,
			systemId: null,
			level: 0
		};
	},
	created () {
		this._getLocal();
	},
	methods: {
		getLanguageStr,
		floatFix: lib.floatFix,
		timeFormat: lib.timeFormat,
		getTypeText: lib.getTypeText,
		convertData: lib.convertData,
		show (data) {
			this.basicInfo = data.basicInfo;
			this.stationId = data.stationId;
			this.systemId = data.systemId;
			this.level = data.level;
			this._showChart();
		},
		_getLocal () {
			this.local = getLocal();
		},
		disabledDate (time) {
			let day = new Date().getTime();
			return day < time;
		},
		paramChooiceShow () {
			let cloneChart = _.cloneDeep(this.chartList);
			cloneChart.forEach(el => {
				el.isBeingSelected = el.default;
			});
			this.$refs.DeviceDetailParam.show(_.cloneDeep(this.chartList), cloneChart, true);
		},
		leave () {
	    	this.paramChooiceActive = false;
	    	this.$refs.DeviceDetailParam.showParam = false;
	    },
	     // 保持参数选择
	    beingParamArray (data) {
	    	this.chartList = [];
	      	this.chartList = data;
	    },
		// 参数选择
		updateShowParamArray (data) {
			this.chartList = [];
			this.chartList = data;
			if (this.ActiveIndex == 0) {
				this._getDayData();
			} else if (this.ActiveIndex == 1) {
				this._getMonthData();
			} else if (this.ActiveIndex == 2) {
				this._getYearData();
			} else {
				this._getTotalData();
			}
		},
		// 时区转换成毫秒
		mz () {
			let sec = stage.time.timezoneMap[this.basicInfo.region.timezone];
			if (sec) {
				sec = sec.offset;
			} else {
				sec = mz.tz(this.basicInfo.region.timezone)._offset * 60;
			}
			return sec * 1000;
		},
		// 日历
		dateChange (str) {
			// type day(日) week(周) month(月) year(年) all(总)
			let type = this.timeChoose[this.ActiveIndex].type;
			let val = this.$refs.date.text;
			// var date=new Date(val);
			let today = `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`;
			let month = `${new Date().getFullYear()}/${new Date().getMonth() + 1}`;
			let year = `${new Date().getFullYear()}`;
			// if(new Date(val).getTime()<new Date(today).getTime()){
			var date = new Date(type == 'month' || type == 'quarter' ? val.split('~').pop() + '/01' : val.split('~').pop());
			let step;
			switch (type) {
			case 'day':
				if (str === 'perv') {
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(today).getTime()) {
					step = 1;
				} else {
					step = 0;
				}
				// var step = str === 'next'&&new Date(val).getTime()<new Date(today).getTime() ? 1: -1
				date.setDate(date.getDate() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'month':
				if (str === 'perv') {
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(month).getTime()) {
					step = 1;
				} else {
					step = 0;
				}
				date.setMonth(date.getMonth() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'quarter':
				if (str === 'perv') {
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(today).getTime()) {
					step = 1;
				} else {
					step = 0;
				}
				this.curQuarter = Math.ceil((date.getMonth() + 1 + step) / 3);
				date.setMonth(date.getMonth() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'year':
				if (str === 'perv') {
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(year).getTime()) {
					step = 1;
				} else {
					step = 0;
				}
				date.setFullYear(date.getFullYear() + step);
				this.$refs.date.selectOk(date);
				break;
			default:
				break;
			}
		},
		// 获取天数
		_getCountDays () {
			let curDate = _.cloneDeep(this.time);
			let curMonth = curDate.getMonth() + 1;
			let curYear = curDate.getFullYear();
			return new Date(curYear, curMonth, 0).getDate();
		},
		// 曲线图
		_showChart () {
			this.detailData = {};
			this.isChart = true;
			this.chartList = {};
			for (let attr in this.proportion) {
				this.proportion[attr] = 0;
			}
			// 日曲线图
			if (this.ActiveIndex == 0) { // 日
				this.chartList = [
					{
						name: getLanguageStr('word977', '用电功率'),
						type: 'usePower',
						selected: true,
						isBeingSelected: true,
						default: true,
						unit: 'W',
						data: []
					}
				];
				this._chartDay();
			} else if (this.ActiveIndex == 1) { // 月图表
				let dateNum = this._getCountDays();
				this.chartList = [
					{
						name: getLanguageStr('word527', '当日用电量'),
						unit: 'kWh',
						type: 'useValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(dateNum)
					}
				];
				this._chartMonth();
			} else if (this.ActiveIndex == 2) { // 年
				this.chartList = [
					{
						name: getLanguageStr('word528', '当月用电量'),
						unit: 'kWh',
						type: 'useValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(12)
					}
				];
				this._chartYear();
			} else if (this.ActiveIndex == 3) { // 总
				this._totalData();
			}
		},
		// 日图表其他数据
		powerDay () {
			let requestId;
			let chooseDay = {
				'year': this.time.getFullYear(),
				'month': this.time.getMonth() + 1,
				'day': this.time.getDate()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			return new Promise((resolve, reject) => {
				equipmentApi.PowerDayHistory(requestId, chooseDay).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 整合日图表数据
		_getDayData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				for (let attr in chartData) {
					chartData[attr].data = [];
					if (this.detailData.records.length) {
						this.detailData.records.forEach((val, index) => {
							chartData[attr].data.push([val.dateTime * 1000 + this.mz(), val[chartData[attr].type]]);
						});
						chartData[attr].data = lib.sortData(chartData[attr].data, {byKey: 0});
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					if (this.ChartData[attr].unit) {
						if (yTitle.indexOf(this.ChartData[attr].unit) <= 0) {
							yTitle.push(this.ChartData[attr].unit);
						}
						this.ChartData[attr].yAxis = yTitle.indexOf(this.ChartData[attr].unit);
					} else this.ChartData[attr].yAxis = 0;
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				if (yTitle.length == 0) {
					yTitle = [''];
				}
				this.defChartMonthOption = { // d
					yTitle: yTitle,
					opposite: true,
					startDate: this.time.getTime()
				};
			} else {
				this.ChartData = [];
			}
		},
		resetChart () {
			this.detailData = {};
			this.tempData = [];
			this.chartData = [];
		},
		// 日图表数据
		_chartDay () {
			this.$refs.chartLine.showLoading();
			Promise.all([this.powerDay()]).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'day') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					if (this.$refs.chartLine) this.$refs.chartLine.hideLoading();
					this.isChart = false;
					this.detailData = response[0];
					// this.tempData=response[1]
					if (response[0].records.length == 0) {
						this.ChartData = [];
					} else {
						this._getDayData();
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartLine.hideLoading();
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
			// equipmentApi.cancelRequest()
		},
		// 月图表其他数据
		powerMonth () {
			let requestId;
			let chooseDay = {
				'year': this.time.getFullYear(),
				'month': this.time.getMonth() + 1
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			return new Promise((resolve, reject) => {
				equipmentApi.PowerMonthHistory(requestId, chooseDay).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 整合月数据
		_getMonthData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				let dateNum = this._getCountDays();
				for (let attr in chartData) {
					chartData[attr].data = new Array(dateNum);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					if (chartData[attr].type == 'weatherPic') { // 处理天气类型
						this.tempData.forEach(val => {
							chartData[attr].data[new Date(val.datetime * 1000 + this.mz()).getDate() - 1] = val.weatherPic;
						});
					} else if (chartData[attr].type == 'temperature') {
						if (this.tempData.length) {
							this.tempData.forEach(val => {
								chartData[attr].data[new Date(val.datetime * 1000 + this.mz()).getDate() - 1] = Number(val.temp);
							});
						}
					} else {
						this.detailData.records.map((val, index) => {
							chartData[attr].data[parseInt(val.day) - 1] = Number(val[chartData[attr].type]);
						});
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					if (this.ChartData[attr].unit) {
						if (yTitle.indexOf(this.ChartData[attr].unit) <= 0) {
							yTitle.push(this.ChartData[attr].unit);
						}
						this.ChartData[attr].yAxis = yTitle.indexOf(this.ChartData[attr].unit);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				if (yTitle.length == 0) {
					yTitle = [''];
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						timeType: 'month',
						opposite: true,
						xCategories: new Array(dateNum)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + 1;
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
		},
		// 月图表数据
		_chartMonth () {
			this.$refs.chartColumn.showLoading();
			Promise.all([this.powerMonth()]).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'month') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					this.isChart = false;
					this.detailData = response[0];
					this.tempData = response[1];
					if (response[0].records.length == 0) {
						this.ChartData = [];
					} else {
						this._getMonthData();
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 季度图表
		// _charQuarter(){
		// 	lib.loadingChange($("#chartColumn [Loading]"),true);
		// 	let chooseQuarter={
		// 		year:lib.timeFormat(this.time,"inc",'%Y'),
		// 		quarter: this.curQuarter
		// 	}
		// 	// equipmentApi.cancelRequest()
		// 	equipmentApi.PowerQuarterHistory(this.stationId,chooseQuarter.year,chooseQuarter.quarter).then(response=>{
		// 		this.isChart=false
		// 		if(!response)return
		// 		lib.loadingChange($("#chartColumn [Loading]"),false);
		// 		this.detailData=response
		// 		if(this.detailData.data.length==0){
		// 			this.ChartData=[];
		// 		}else{
		// 			let n = (this.curQuarter-1)*3+1
		// 			for(let attr in this.chartList){
		// 				$.each(this.chartList[attr].data,(index)=>{
		// 					this.chartList[attr].data[index]=null
		// 				})
		// 				this.detailData.data.map((val,index)=>{
		// 					this.chartList[attr].data[parseInt(val.date)-n]=Number(val[attr])
		// 				})
		// 				this.ChartData.push(this.chartList[attr])
		// 			}
		// 			this.defChartMonthOption=function(){//默认月图表参数
		// 				let obj={
		// 					yTitle:['kWh','CNY','h'],
		// 					timeType:"quarter",
		// 					opposite:true,
		// 					xCategories:new Array(3)
		// 				}
		// 				$.each(obj.xCategories,function(index){
		// 					obj.xCategories[index]= n+index;
		// 				});
		// 				return obj;
		// 			}()
		// 		}
		// 	},error=>{
		// 		lib.loadingChange($("#chartColumn [Loading]"),false);
		// 		this.isChart=false
		// 		!_.isEmpty(error) && this.$notify(error)
		// 	})
		// },
		_getYearData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				for (let attr in chartData) {
					chartData[attr].data = new Array(12);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					this.detailData.records.map((val, index) => {
						chartData[attr].data[parseInt(val.month) - 1] = Number(val[chartData[attr].type]);
					});
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					yTitle.push(this.ChartData[attr].unit);
					if (attr > 0) {
						this.ChartData[attr].yAxis = Number(attr);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						timeType: 'year',
						opposite: true,
						xCategories: new Array(12)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + 1;
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
		},
		// 年图表数据
		_chartYear () {
			this.$refs.chartColumn.showLoading();
			let requestId;
			let chooseYear = {
				'year': this.time.getFullYear()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			// equipmentApi.cancelRequest()
			equipmentApi.PowerYearHistory(requestId, chooseYear).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'year') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					this.isChart = false;
					if (!response) return;
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					this.detailData = response;
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
					} else {
						this._getYearData();
					}
				}
			}, error => {
				!_.isEmpty(error) && this.$notify(error);
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				this.isChart = false;
			});
		},
		// 整合总图表数据
		_getTotalData () {
			if (this.detailData.records.length > 0) {
				let startYear = [];
				for (let attr in this.detailData.records) {
					startYear.push(this.detailData.records[attr].year);
				}
				startYear = lib.sortData(startYear)[0]; // 获取最小的年份
				let endYear = lib.timeFormat(new Date(), 'inc', '%Y'); // 获取当年年份
				let YearNum = Number(endYear) - Number(startYear) + 1; // X轴总数
				this.rangeDate = [new Date(String(startYear)), new Date(endYear)];

				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				for (let attr in chartData) {
					chartData[attr].data = new Array(YearNum);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					this.detailData.records.map((val, index) => {
						chartData[attr].data[parseInt(val.year) - Number(startYear)] = Number(val[chartData[attr].type]);
					});
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					yTitle.push(this.ChartData[attr].unit);
					if (attr > 0) {
						this.ChartData[attr].yAxis = Number(attr);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						timeType: 'all',
						opposite: true,
						xCategories: new Array(YearNum)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + Number(startYear);
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
			// for(let attr in this.chartList){
			// 	$.each(this.chartList[attr].data,(index)=>{
			// 		this.chartList[attr].data[index]=null
			// 	})
			// 	this.detailData.records.map((val,index)=>{
			// 		this.chartList[attr].data[parseInt(val.year)-Number(startYear)]=Number(val[attr])
			// 	})
			// 	this.ChartData.push(this.chartList[attr])
			// }
			// this.defChartMonthOption=function(){//默认月图表参数
			// 	let obj={ //d
			// 		yTitle:['kWh','h','kWh/㎡','%'],
			// 		timeType:"all",
			// 		opposite:true,
			// 		xCategories:new Array(YearNum)
			// 	}
			// 	$.each(obj.xCategories,function(index){
			// 		obj.xCategories[index]=index+Number(startYear);
			// 	});
			// 	return obj;
			// }()
		},
		// 总图表数据
		_totalData () {
			this.$refs.chartColumn.showLoading();
			let requestId;
			let chooseTotal = {
				'startYear': 2000,
				'endYear': this.time.getFullYear()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			// equipmentApi.cancelRequest()
			equipmentApi.PowerTotalHistory(requestId, chooseTotal).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'all') { // 防止快速切换导致hideLoading()方法不能执行
					this.ChartData = [];
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					this.isChart = false;
					if (!response) return;
					this.detailData = response;
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
					} else {
						let startYear = [];
						for (let attr in this.detailData.records) {
							startYear.push(this.detailData.records[attr].year);
						}
						startYear = lib.sortData(startYear)[0]; // 获取最小的年份
						let endYear = lib.timeFormat(new Date(), 'inc', '%Y'); // 获取当年年份
						let YearNum = Number(endYear) - Number(startYear) + 1; // X轴总数
						this.rangeDate = [new Date(String(startYear)), new Date(endYear)];
						this.chartList = [
							{
								name: getLanguageStr('word529', '当年用电量'),
								unit: 'kWh',
								type: 'useValue',
								selected: true,
								isBeingSelected: true,
								default: true,
								data: new Array(YearNum)
							}
						];
						this._getTotalData();
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				!_.isEmpty(error) && this.$notify(error);
				this.isChart = false;
			});
		},
		_timePicker (item, index) {
			this.$refs.DeviceDetailParam.showParam = false;
			// this.CHANGE(index)
			this.ActiveIndex = index;
			this.$nextTick(() => {
				this._showChart();
			});
		}
	}

};
</script>

<style lang="scss" scoped>
.datepicker{
	width: 125px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/ConsumptionHistory.vue